import { forwardRef, type Ref, type SVGProps } from "react";
const IconTagDollarSignFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28.001 2h-10a1.97 1.97 0 0 0-1.41.59l-14 14a1.974 1.974 0 0 0 0 2.82l10 10a1.98 1.98 0 0 0 2.82 0l14-14a1.97 1.97 0 0 0 .59-1.41V4a2.006 2.006 0 0 0-2-2m-4 8a2 2 0 1 1-2-2 2.006 2.006 0 0 1 2 2m-12.94 10.54a1 1 0 0 1-.06-.33.54.54 0 0 1 .61-.56.64.64 0 0 1 .62.43 2.13 2.13 0 0 0 2.05 1c.88-.06 1.41-.5 1.41-1.18 0-.63-.38-.96-1.4-1.22l-1.01-.24c-1.54-.36-2.25-1.06-2.25-2.21a2.31 2.31 0 0 1 2.14-2.27v-.29a.645.645 0 1 1 1.29 0v.26a2.54 2.54 0 0 1 2.29 1.59 1.4 1.4 0 0 1 .05.32c0 .31-.22.5-.58.5a.71.71 0 0 1-.65-.42 2 2 0 0 0-1.89-.99c-.79.09-1.33.52-1.33 1.14 0 .59.4.95 1.29 1.19l1.04.24c1.63.38 2.32 1.04 2.32 2.21 0 1.56-1.27 2.24-2.53 2.37v.26a.645.645 0 1 1-1.29 0v-.29a2.48 2.48 0 0 1-2.12-1.51"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTagDollarSignFilledSVG);
ForwardRef.displayName = "IconTagDollarSignFilled";
export { ForwardRef as IconTagDollarSignFilled };
